import React, {Component} from "react";
import PanelGroupController from "../PanelGroupController";
import ActionButton from "../ActionButton";
import AvailabilityPropertiesPanel from "./AvailabilityPropertiesPanel";
import {fromJS} from "immutable";
import FilterPanel from "../panels/FilterPanel";

const CONTEXT = "availability";

class AvailabilityPanelSet extends Component {

  render() {
    if (this.props.context !== CONTEXT) return null;

    const filterOptions = fromJS([
      {id: "europe", label: "Europe"},
      {id: "us", label: "US States"},
      {id: "world", label: "World"}
    ])

    return (
      <div className="content">
        <FilterPanel
          expanded={true}
          options={filterOptions}
          onClick={(item) => this.props.setAvailabilityFilter(item.get("id"))}
          filter={this.props.availabilityFilter}
          />
        <AvailabilityPropertiesPanel 
          expanded={true} 
          selectedAvailability={this.props.selectedAvailability}
          hasSelection={this.props.hasSelection}
          />
        <PanelGroupController title="Actions">
          <ActionButton label="Change Availability" active={this.props.hasSelection} onClick={this.handleChangeAvailability.bind(this)} />
          <ActionButton label="Assign Warehouse" active={this.props.hasSelection} onClick={this.handleAssignWarehouse.bind(this)} />
        </PanelGroupController>

      </div>
    );
  }

  handleChangeAvailability() {
    this.props.requestSetAvailability(this.props.selectedAvailability);
  }

  handleAssignWarehouse() {
    this.props.requestAssignWarehouseToLocation(this.props.selectedAvailability);
  }

}

export default AvailabilityPanelSet;